import { Component, Input } from "@angular/core";
import { DATA_DISPLAY_CARD_STYLE } from "./interfaces/data-display-card.interface";

@Component({
  selector: "app-data-display-card",
  templateUrl: "./data-display-card.component.html",
  styleUrl: "./data-display-card.component.scss",
  standalone: false
})
export class DataDisplayCardComponent{

  @Input() cardTitle: string = '';
  @Input() cardIcon: string;
  @Input() dataValue: string | number = '';
  @Input() theme: DATA_DISPLAY_CARD_STYLE | string = DATA_DISPLAY_CARD_STYLE.DEFAULT;

  cardIconMap = {
    [DATA_DISPLAY_CARD_STYLE.DEFAULT]: 'thumb_up',
    [DATA_DISPLAY_CARD_STYLE.SUCCESS]: 'check_circle',
    [DATA_DISPLAY_CARD_STYLE.IN_PROGRESS]: 'warning',
    [DATA_DISPLAY_CARD_STYLE.REJECTED]:'cancel'
  };
}

